exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse-item .card-header{cursor:pointer}.collapse-item .card-header-icon{transition:transform .377s ease}.collapse-item .card-content{padding-top:0;padding-bottom:0;overflow:hidden}.collapse-item .card-content-box{padding-top:20px;padding-bottom:20px}.collapse-item.is-active>.card-header>.card-header-icon{transform:rotate(90deg)}", ""]);

// exports
